import type { FC, ReactNode } from 'react'

import { Marquee } from '@/components/generals/marquee'
import { Wordmark } from '@/components/generals/wordmark'
import { Reveal } from '@/components/generals/reveal'
import { customerLogos } from '@/constants/home'

export const LogoMarquee: FC = (): ReactNode => {
    return (
        <section id='customers' aria-labelledby='customers-title' className='relative'>
            <Reveal className='fc-container'>
                <div className='flex flex-col items-center gap-7 border-t border-hairline pb-6 pt-10 md:flex-row md:gap-10 md:pb-8 md:pt-12'>
                    <h2 id='customers-title' className='shrink-0 text-center text-[14px] font-medium leading-snug text-slate md:w-[220px] md:text-left'>
                        Trusted by fast-growing
                        <br className='hidden md:block' />
                        {' '}companies around the world
                    </h2>

                    <Marquee duration={55} label='Customer logos' className='w-full flex-1' trackClassName='gap-14 pr-14'>
                        {customerLogos.map(name => (
                            <Wordmark
                                key={name}
                                name={name}
                                className='text-[20px] text-[#8b8b95] transition-colors duration-300 hover:text-ink'
                            />
                        ))}
                    </Marquee>
                </div>
            </Reveal>
        </section>
    )
}
